"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalAttributesTerseSchema = exports.SignalAttributesDenormalizedSchema = void 0;
exports.transformToTerseFormat = transformToTerseFormat;
exports.getSignalAttributesInDenormalizedFormat = getSignalAttributesInDenormalizedFormat;
exports.convertSignalAttributesToSignal = convertSignalAttributesToSignal;
exports.createMockSignalAttributes = createMockSignalAttributes;
exports.addSignalIdsToAttributes = addSignalIdsToAttributes;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const CadstromUid_1 = require("../../CadstromUid");
const generate_readable_id_1 = require("../../GenerateReadableId/generate-readable-id");
exports.SignalAttributesDenormalizedSchema = zod_1.z.object({
    signalName: zod_1.z.string(),
    power: zod_1.z.boolean(),
    ground: zod_1.z.boolean(),
    analog: zod_1.z.boolean(),
    digital: zod_1.z.boolean(),
    exposedPad: zod_1.z.boolean(),
    noConnect: zod_1.z.boolean(),
    activeLow: zod_1.z.boolean(),
    direction: zod_1.z.nativeEnum(sigma_engine_shared_1.DesignModels.SignalDirection).nullable(),
    description: zod_1.z.string().nullable(),
});
exports.SignalAttributesTerseSchema = zod_1.z.object({
    signalName: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    attributes: zod_1.z.array(zod_1.z.string()),
    direction: zod_1.z.nativeEnum(sigma_engine_shared_1.DesignModels.SignalDirection).optional(),
});
function transformToTerseFormat(denormalized) {
    const attributes = [];
    for (const [key, value] of Object.entries(denormalized)) {
        if (typeof value === 'boolean' && value === true) {
            attributes.push(key);
        }
    }
    return {
        signalName: denormalized.signalName,
        attributes,
        ...(denormalized.description !== null && { description: denormalized.description }),
        ...(denormalized.direction !== null && { direction: denormalized.direction }),
    };
}
function getSignalAttributesInDenormalizedFormat(signal) {
    return {
        signalName: signal.name,
        power: signal.attributes?.power ?? false,
        ground: signal.attributes?.ground ?? false,
        analog: signal.attributes?.analog ?? false,
        digital: signal.attributes?.digital ?? false,
        exposedPad: signal.attributes?.exposedPad ?? false,
        noConnect: signal.attributes?.noConnect ?? false,
        activeLow: signal.attributes?.activeLow ?? false,
        direction: signal.signalDirection ?? null,
        description: signal.description ?? null,
    };
}
function convertSignalAttributesToSignal(attributes, logger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)()) {
    const signal = {
        id: attributes.id,
        name: attributes.signalName,
        padRefs: [],
        pinRefs: [],
        signalDirection: attributes.direction ?? undefined,
        attributes: {
            power: attributes.power,
            ground: attributes.ground,
            analog: attributes.analog,
            digital: attributes.digital,
            exposedPad: attributes.exposedPad,
            noConnect: attributes.noConnect,
            activeLow: attributes.activeLow,
        },
        description: attributes.description ?? undefined,
    };
    const parseResult = sigma_engine_shared_1.DesignModels.SignalSchema.safeParse(signal);
    if (!parseResult.success) {
        logger.warn('ConvertSignalAttributesToSignal_InvalidFieldsDropped', {
            signalId: attributes.id,
            signalName: attributes.signalName,
            errors: parseResult.error.flatten().fieldErrors,
        });
        return {
            id: attributes.id,
            name: attributes.signalName,
            padRefs: [],
            pinRefs: [],
        };
    }
    return parseResult.data;
}
function createMockSignalAttributes(overrides = {}) {
    return {
        signalName: 'TEST',
        power: false,
        ground: false,
        analog: false,
        digital: false,
        exposedPad: false,
        noConnect: false,
        activeLow: false,
        direction: sigma_engine_shared_1.DesignModels.SignalDirection.Input,
        description: 'Test signal',
        ...overrides,
    };
}
function addSignalIdsToAttributes(attributes) {
    const signalAttributesWithIds = attributes.map((signalAttribute) => ({
        ...signalAttribute,
        id: (0, generate_readable_id_1.generateReadableId)(CadstromUid_1.CadstromObjectType.Signal, signalAttribute.signalName),
    }));
    return signalAttributesWithIds;
}
//# sourceMappingURL=signal-attributes-denormalized.js.map